import { Color24, Colors24 } from '@grammarly/badger-ui'

interface WebinarProps {
  color?: Color24
}

export const ReportIcon = (props: WebinarProps) => {
  const { color = 'green60' } = props
  const strokeColor = Colors24[color]
  return (
    <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 3.8H10M4 6.6H10M4 9.4H10M4 12.2H7M2.33333 15H11.6667C12.403 15 13 14.403 13 13.6667V2.33333C13 1.59695 12.403 1 11.6667 1H2.33333C1.59695 1 1 1.59695 1 2.33333V13.6667C1 14.403 1.59695 15 2.33333 15Z"
        stroke={strokeColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
